import { observer } from 'mobx-react-lite'
import { LegendCard } from '@/features/legends/LegendList/components/LegendCard'
import type { LegendListItemViewModel } from '@/features/legends/LegendList/LegendListItemViewModel'
import { links } from '@/utils/link'

export interface LegendCardContainerProps {
  vm: LegendListItemViewModel
}

export const LegendCardContainer = observer(function LegendCardContainer({
  vm,
}: LegendCardContainerProps) {
  const version = vm.latestVersion
  return (
    <LegendCard
      to={links.legend(vm.legend.id)}
      name={version.name}
      description={version.description}
      serviceType={version.serviceType}
      status={vm.status}
      version={version.version}
      versionStatus={vm.versionStatus}
      hasUnpublishedChanges={vm.hasUnpublishedChanges}
      isInactive={vm.legend.inactive}
      dateLabel={vm.dateLabel}
      updatedBy={version.lastUpdatedBy}
      canModify={vm.canModify}
      isToggleActivationPending={vm.toggleActivation.pending}
      onEdit={vm.edit}
      onToggleActivation={vm.toggleActivation}
      testId={`legend-card-${vm.legend.id}`}
    />
  )
})
